interface DemandesConge {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: DemandeConge[];
}

interface ResponseStats {
  all: number;
  inactive: number;
  invited: number;
  disabled: number;
  active: number;
  archive: number;
  societyVisible: boolean;
  serviceVisible: boolean;
}

interface DemandeConge {
  id: string;
  fullName: string | null;
  firstName: string;
  lastName: string;
  pathImg: string | null;
  site: string;
  fonction: string;
  departement: string;
  society: string;
  service: string;
  anciennete: string;
  ancienneteYear: number;
  ancienneteMonth: number;
  contrat: string;
  statut: string;
  rate: string;
  hiringDate: string;
  endDate: string | null;
  lastActivity: string;
  anniversary: string | null;
  hiringAnniversary: string | null;
  conges: unknown[];
  contractDuration: ContractDuration | null;
  user: SelectItem;
  accessSource: DemandAccessSource | null;
}

export enum DemandAccessSource {
  Own,
  ApprovalCircle,
  Permission,
}

interface ContractDuration {
  dateRepresentation: string;
  duration: number;
  isObsolute: boolean;
}

interface tableFilter {
  start: number;
  length: number;
  search: Search;
  order: Order[];
  filters: FilterDetails;
}

interface Search {
  value: string;
  regex: boolean;
}

interface Order {
  column: string;
  dir: string;
  custom: boolean;
}

interface FilterDetails {
  siteIds: number[] | null;
  departmentIds: number[] | null;
  companyIds: number[] | null;
  serviceIds: number[] | null;
  contractTypes: string[] | null;
  functionIds: number[] | null;
  maxSeniority?: number | null;
  minSeniority?: number | null;
  maxFillingRate?: number | null;
  minFillingRate?: number | null;
  createdOn?: string | null;
  status: number[];
  events: string | null;
  tagIds?: number[] | null;
}

interface EmployeesResponse {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: Employee[];
}

interface Employee {
  id: string;
  fullName: string | null;
  firstName: string;
  lastName: string;
  pathImg: string | null;
  site: string;
  fonction: string;
  departement: string;
  society: string;
  service: string;
  anciennete: string;
  ancienneteYear: number;
  ancienneteMonth: number;
  contrat: string;
  status: string;
  rate: string;
  hiringDate: string;
  endDate: string | null;
  lastActivity: string;
  events: SelectItem[];
  tags?: {
    id: number;
    tagId: number;
    title: string;
    color: string;
    isPublic: boolean;
    isMine: boolean;
  }[];
}
interface OrgUser {
  id: string;
  name: string;
  email: string;
  picturePath: string | null;
  fonction: string;
  departement: string;
  directSubordinates: number;
  totalSubordinates: number;
  hasSubordinates: boolean;
  supervisorId: string | null;
  children: OrgUser[];
}

interface OrgNodeData {
  id: string;
  name: string;
  title: string;
  department: string;
  subordinates: number;
  avatar?: string;
  level: number;
  hasChildren: boolean;
  isExpanded: boolean;
  onToggleExpand: (nodeId: string) => void;
  nodeId: string;
  originalNode: OrgUser | null;
  totalSubordinates: number;
}

interface HierarchyNodeData {
  id: string;
  name: string;
  title: string;
  department: string;
  subordinates: number;
  totalSubordinates: number;
  avatar: string | null;
  hasChildren: boolean;
  isExpanded: boolean;
  isSkeleton: boolean;
  skeletonIndex?: number;
  parentId: string | null;
  originalNode: OrgUser | null;
  children: HierarchyNodeData[] | null;
}

interface CollaborateurorgChartProps {
  filters?: tableFilter;
  refresh?: boolean;
  searchValue?: string;
  clearSearchValue: () => void;
  clearSearchContainer: () => void;
}

export type {
  EmployeesResponse,
  Employee,
  DemandeConge,
  DemandesConge,
  ContractDuration,
  tableFilter,
  ResponseStats,
  OrgUser,
  OrgNodeData,
  CollaborateurorgChartProps,
  HierarchyNodeData,
};
